import { Component } from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less']
})
export class AppComponent {
  title = 'front-electiv';

  constructor(private router: Router) {
  }

  actionVote() {
    this.router.navigate(['/poll-choice']);
  }

  ngOnInit() {
  }
}
